const mutations = {
  setCart (state, cart) { state.cart = cart },
  setCartDialogFlag (state, cartDialogFlag) { state.cartDialogFlag = cartDialogFlag }
}
export default mutations
